import React from "react";
import { Dropdown } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BsFilter } from "react-icons/bs";

const EnabledOnlyFilter = ({
  t,
  viewFilter,
  onViewFilterChange,
  dropdownId = "enabled-only-filter-dropdown",
}) => {
  return (
    <>
      <span className="Filter_status me-2">
        {viewFilter === "enabled" ? t("EnabledOnly.label") : t("All.label")}
      </span>
      <Dropdown className="me-2">
        <Dropdown.Toggle variant="outline-secondary" id={dropdownId}>
          <BsFilter />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            active={viewFilter === "enabled"}
            onClick={() => onViewFilterChange("enabled")}
          >
            {t("ShowEnabledOnly.label")}
          </Dropdown.Item>
          <Dropdown.Item
            active={viewFilter === "all"}
            onClick={() => onViewFilterChange("all")}
          >
            {t("ShowAll.label")}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default withTranslation()(EnabledOnlyFilter);
